import Alpine from "alpinejs";

const currentHref = location.href;
Alpine.data("header", () => ({
    menuOpen: false,
    init() {
        if ("scrollbar-gutter" in document.documentElement.style) {
            this.header["x-trap.inert"] = function () {
                return this.menuOpen;
            };
            this.$watch("menuOpen", (value) => {
                document.documentElement.classList.toggle("overflow-hidden", value);
                document.documentElement.classList.toggle("menu-open", value);
            });
        } else {
            this.header["x-trap.noscroll.inert"] = function () {
                return this.menuOpen;
            };
        }

        try {
            document.querySelectorAll(".c-main-navigation--overlay-grid--languages .c-linkable").forEach((element) => {
                let langCode = element.getAttribute('href').substring(1);
                let hreflang = document.querySelector('link[rel="alternate"][hreflang="' + langCode + '"]');
                element.setAttribute('href', hreflang.getAttribute('href'));
            });
        } catch (e) {
            // ignore.. probably it's a shared document only with a canonical meta tag
        }
    },
    current(href) {
        if (currentHref == href) {
            return true;
        }
        return currentHref.startsWith(`${href}/`);
    },
    header: {
        "@beforeunload.window"() {
            this.menuOpen = false;
        },
        "@keydown.window.escape"() {
            this.menuOpen = false;
        },
        "@click.outside"() {
            this.menuOpen = false;
        },
    },
}));
